











import Vue, { PropType } from 'vue';

import { BasePacket, BasePacketKind } from '../models/packet';

import PacketCardSinglePoint from '@/components/PacketCardSinglePoint.vue';
import PacketCardMultiPoint from '@/components/PacketCardMultiPoint.vue';

export default Vue.extend({
  components: {
    PacketCardSinglePoint,
    PacketCardMultiPoint
  },

  props: {
    packet: {
      type: Object as PropType<BasePacket>,
      required: true
    },
    navDisabled: {
      type: Boolean,
      default: false
    },
    hoverDisabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isSinglePoint(): boolean {
      return this.packet.kind === BasePacketKind.SINGLE_POINT;
    }
  },

  methods: {
    onPacketClick() {
      this.$emit('packet-click', this.packet);

      if (!this.navDisabled) {
        const orgId = this.$route.params['organizationId'] as string;

        if (!this.packet.external) {
          this.$router.push({
            name: 'OrganizationPacket',
            params: {
              organizationId: orgId,
              packetId: `${this.packet.packetId}`
            }
          });
        } else {
          this.$router.push({
            name: 'PublicPacket',
            params: {
              organizationId: orgId,
              packetId: `${this.packet.packetId}`
            }
          });
        }
      }
    }
  }
});
